/**
 * Created by christiancueni on 23/05/18.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {Injectable} from '@angular/core';
import { IS_APP } from "../app.constants";

@Injectable()
export class StatusBarService {

    constructor() {}

    initStatusBar() {
        if (IS_APP) {
            document.addEventListener('deviceready', this.onReady.bind(this), false);
        }
    }

    private onReady() {
        StatusBar.backgroundColorByHexString("#001155");
    }
}
